module.exports = __webpack_public_path__ + "img/mms_logo_white.3c879d05.svg";